
// src/helpers/socket-rsync.js

import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AccessToken from '../actions/access-token'
import { emitAlertMessage, clearAlertMessage } from '../actions/alert-message'
import io from 'socket.io-client'
import actions from '../actions'
import config from '../config';
import context from './context'
import each from 'lodash/each'
import map from 'lodash/map'
import socket from 'socket.io-client/lib/socket'

const MESSAGE_TYPES = {
  notification: 'notification_id',
  diary: 'diary_id',
  group: 'group_id',
  diary_delete: 'diary_id',
  group_delete: 'group_id',
  chat: 'message_id',
  chat_room: 'chat_room_id',
  chat_meta_info: 'chat_meta_info',
  template: 'template_id',
  kpi: 'kpi_id',
  division: 'division_id',
  division_delete: 'division_id',
}

const socketStore = {
  socket: undefined,
  status: undefined,
}

export const emitSocket = (event, params)=> {
	if (socketStore.socket && socketStore.status == 'connected') {
		try {
			socketStore.socket.emit(event, params)
			return true
		}
		catch (e) {
			return undefined
		}
	} else
		return undefined
}

/*
 * provideRsync(Component):
 *   Componentに対して以下の関数を提供します
 *     - props.initializeSocket(user): userに対するWebsocketのコネクションを確立します
 *     - props.refreshSocket: Websocketのコネクションを再確立します
 *   ComponentがUnmountされる時に以下の機能を実行します
 *     - Websocketのコネクションを削除します
 *   Componentの子孫に対して以下の関数をcontextに埋め込みます
 *     - emitSocket(event, params): Websocketにメッセージを送信します
 */

export const mapStateToProps = (state)=> {
  return {
    socketStatus: state.socket.status,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  function _initializeSocket(user) {
    socketStore.socket = io(config.webSocketUrl, { forceNew: true, transports: ['websocket'] })
    socketStore.socket.on('reconnecting', (num)=> {
      socketStore.status = 'reconnecting'
      if (num > 3) {
        dispatch(actions.socketReconnecting())
        dispatch(emitAlertMessage('error:サーバ切断', 'error'))
      }
    })
    socketStore.socket.on('connect', ()=> {
      AccessToken.get((token)=> {
        socketStore.socket.emit('authenticate', {
          user_id: user.user_id,
          access_token: token,
        })
        socketStore.status = 'connected'
        dispatch(clearAlertMessage())
        dispatch(actions.socketConnect())
      })
    })
    socketStore.socket.on('reconnect_failed', ()=> {
      _destroySocket()
      setTimeout(()=> _initializeSocket(user), 5000)
    })
    socketStore.socket.on('request_authenticate', ()=> {
      AccessToken.get((token)=> {
        socketStore.socket.emit('authenticate', {
          user_id: user.user_id,
          access_token: token,
        })
        socketStore.status = 'connected'
        dispatch(clearAlertMessage())
        dispatch(actions.socketConnect())
      })
    })
    each(MESSAGE_TYPES, (dummy, message_type)=> {
      socketStore.socket.on(message_type, (param)=> {
        param = JSON.parse(param)
        dispatch(actions.socketReceive(message_type, param))
      })
    })
  }

  function _destroySocket() {
    if (socketStore.socket) {
      dispatch(actions.socketDisconnect())
      socketStore.socket.disconnect()
      socketStore.socket = null
      socketStore.status = undefined
    }
  }

  return {
    initializeSocket: _initializeSocket,
    destroySocket: _destroySocket,
    refreshSocket: ()=> {
      dispatch(actions.socketReconnecting())
      setTimeout(()=> dispatch(actions.socketReconnect()), 0)
    },
    emitSocket
  }
}

export function provideRsync(Component) {
  class RsyncProviderComponent extends React.Component {
    render() {
      return <Component {...this.props} />
    }

    getChildContext() {
      return {
        emitSocket: this.props.emitSocket
      }
    }
  }

  RsyncProviderComponent.childContextTypes = { emitSocket: PropTypes.func }
  return connect(mapStateToProps, mapDispatchToProps)(RsyncProviderComponent)
}

/*
 * requireSocketEmit(Component):
 *   Componentに対して以下の関数を提供します
 *     - props.emitSocket(event, params): Websocketにメッセージを送信します
 */

export function requireSocketEmit(Component) {
  return context({ emitSocket: PropTypes.func })(Component)
}

/*
 * default(message_types)(Component):
 *   Componentに対して以下のコールバックを呼び出します
 *     - props.reseiveSocket(message, message_type): Websocketでmessage_typeのメッセージmessageを受信した場合に呼び出されます
 *     - props.requestSync(props): Websocketのコネクションが確立・再確立した場合に呼び出されます
 */

export default function(){
  const message_types = arguments

  return (Component)=> {
    class RsyncedComponent extends React.PureComponent {
      render() {
        const { socketMessages, ...otherProps } = this.props
        return <Component {...otherProps} />
      }

      componentDidUpdate(prevProps, prevState, snapshot){
        if (message_types.length > 0 && prevProps.socketMessages != this.props.socketMessages) {
          map(message_types, (message_type)=> {
            const current_messages = prevProps.socketMessages[message_type] || []
            const next_messages = this.props.socketMessages[message_type] || []

            if (next_messages.length > current_messages.length) {
              const new_messages = next_messages.slice(current_messages.length)
              each(new_messages, (message)=> this.props.receiveSocket && this.props.receiveSocket(message, message_type, this.props))
            }
          })
        }

        if (prevProps.socketStatus != this.props.socketStatus && this.props.socketStatus == 'connected' && this.props.requestSync) {
          this.props.requestSync(this.props)
        }
      }
    }

    return connect((state)=> {
      return {
        socketMessages: state.socket.items,
        socketStatus: state.socket.status,
      }
    })(RsyncedComponent)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/socket-rsync.js